export default __webpack_public_path__ + "static/media/13.2277f38b.jpg";